import React from 'react';
import LoadingIndicator from './LoadingIndicator';
import * as styles from './LoadingIndicatorModal.module.scss';
import ModalPrimitive from './ModalPrimitive';

const LoadingIndicatorModal = () => {
  return (
    <ModalPrimitive.Root className={styles.modal}>
      <LoadingIndicator delay={0} />
    </ModalPrimitive.Root>
  );
};

export default LoadingIndicatorModal;
